$(document).on('click', '.js-datepicker, .js-datepicker-ym', function () {
  $(this).datepicker('show');
});
